import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { MunicipalityFilter } from '../models/municipality-filter.mode';
import { environment } from './../../../environments/environment';
import { ComplexMunicipalityModel } from './../models/complex-municipality.model';
import { MunicipalityModel } from './../models/municipality.model';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
  }),
};

@Injectable({
  providedIn: 'root',
})
export class MunicipalityService {
  apiUrl = '/api/v1/municipality';

  constructor(
    private http: HttpClient,
    private translateService: TranslateService
  ) {
    if (environment.production || environment.test) {
      this.apiUrl = `${environment.bffUrl}${this.apiUrl}`;
    }
  }

  getAll(
    params: HttpParams,
    filter: MunicipalityFilter
  ): Observable<ComplexMunicipalityModel> {
    if (filter) {
      if (!!filter.name) {
        params = params.append('name', filter.name.trim());
      }
      if (!!filter.city) {
        params = params.append('city', filter.city.trim());
      }
      if (!!filter.country) {
        params = params.append('country', filter.country.trim());
      }

      params = params.append(
        'countBuildings',
        filter.countBuildings.toString()
      );
    }

    if (!params) {
      params = new HttpParams();
    }

    params = params.append('language', this.translateService.currentLang);

    return this.http.get<ComplexMunicipalityModel>(`${this.apiUrl}`, {
      params: params,
    });
  }

  getAllWithoutFiltering(
    language: string
  ): Observable<ComplexMunicipalityModel> {
    return this.http.get<ComplexMunicipalityModel>(
      `${this.apiUrl}/allWithoutFiltering?language=${language}`
    );
  }

  get(id: string): Observable<MunicipalityModel> {
    return this.http.get<MunicipalityModel>(`${this.apiUrl}/${id}`);
  }

  add(model: MunicipalityModel): Observable<MunicipalityModel> {
    model.language = this.translateService.currentLang;

    return this.http.post<MunicipalityModel>(
      `${this.apiUrl}`,
      model,
      httpOptions
    );
  }

  update(model: MunicipalityModel): Observable<MunicipalityModel> {
    model.language = this.translateService.currentLang;

    return this.http.put<MunicipalityModel>(
      `${this.apiUrl}/${model.id}`,
      model,
      httpOptions
    );
  }

  remove(id: string): Observable<boolean> {
    return this.http.delete<boolean>(`${this.apiUrl}/${id}`);
  }

  import(data: string): Observable<boolean> {
    return this.http.post<boolean>(`${this.apiUrl}`, data, httpOptions);
  }
}
